// Module
var code = "<div class=\"info-page\"> <div> <i class=\"mdi mdi-alert-circle-outline mdi-36px\"></i><br> <span class=\"title\" data-i18n=\"msg_info_sensor_only\"></span> <hr> <span class=\"desc\" data-i18n=\"msg_info_select_sensor\"></span> </div> </div> ";
// Exports
export default code;